<template>
  <SelectDropDown
      :id="id"
      :name="name"
      :label="label"
      @selection-change="statusSelected"
      :options="statuses"
      :defaultSelected="defaultSelected ? {id: defaultSelected.enumName} : statuses[0]"
  />
</template>

<script>
import SelectDropDown from "@/shared/components/form/SelectDropDown";
import {mapGetters} from 'vuex';

export default {
  name: "UserRoleDropdown",
  components: {SelectDropDown},
  props: {
    id: String,
    name: String,
    label: String,
    defaultSelected: Object
  },
  created() {
    this.$store.dispatch('fetchUserRoles');
    this.setStatuses();
  },
  data() {
    return {
      statuses: []
    }
  },
  methods: {
    statusSelected(value) {
      this.$emit('selection-change', {
        id: value.dropDownId,
        isDropdown: true,
        name: value.name,
        label: value.label,
        currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
        currentValueId: value.currentValue.id,
        oldValue: value.oldValue
      });
    },
    setStatuses() {
      this.statuses = [];
      this.statuses.push({
        id: 'none',
        name: '(всички)'
      });
      if (this.userRoles && Array.isArray(this.userRoles)) {
        this.userRoles.forEach(status => {
          const tempStatus = {id: status, name: status};
          this.statuses.push(tempStatus)
        });
      }
    }
  },
  computed: {
    ...mapGetters(['userRoles'])
  },
  watch: {
    userRoles: {
      handler() {
        this.setStatuses();
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
